// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StarTwoToneSvg from "@fishx/icons-svg/es/asn/StarTwoTone";
import FishxIcon from '../components/FishxIcon';

var StarTwoTone = function StarTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StarTwoToneSvg
  }));
};

StarTwoTone.displayName = 'StarTwoTone';
export default React.forwardRef(StarTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StarTwoTone.js
// module id = 4190
// module chunks = 0